/* eslint-disable */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { convertTypeString } from '../../../../../helpers/helpers';
import { TogglerKeys } from '../../../../../hooks/useReport';
import { Analysis, IToggleState } from '../../../../../services/reports';
import Toggler from '../../../../Toggler/Toggler';
import { VariationSign } from '../../../SharedEffectReportComponents/EffectReportTemplate/ReportTimestemps/TimestampSigns/TimestampSigns';
import ValueColorBlocks from '../../../SharedEffectReportComponents/EffectReportTemplate/ReportTimestemps/ValueColorBlocks/ValueColorBlocks';
import FiveChallengesCarousel from './FiveChallengesCarousel/FiveChallengesCarousel';
import {
  Legend,
  FlexBlock,
  Header,
  HeaderWrapper,
  Wrapper,
  Text,
} from './FiveChallengesGroupTemplate.styles';

interface FiveChallengesGroupTemplateProps {
  data: {
    clarity?: Analysis;
    quality?: Analysis;
    relationship?: Analysis;
    behaving?: Analysis;
    learning?: Analysis;
  };
}

const order = [
  'EFFECT CLARITY',
  'EFFECT QUALITY',
  'EFFECT RELATIONSHIP',
  'EFFECT BEHAVING',
  'EFFECT LEARNING',
];

const FiveChallengesGroupTemplate: React.FC<FiveChallengesGroupTemplateProps> = ({ data }) => {
  const [activeTopic, setActiveTopic] = useState(0);
  const [togglersState, setTogglersState] = useState<IToggleState>({
    historical_result: false,
    variation_between_respondents: false,
    organization_mean: false,
    external_benchmark: false,
    team_manager: false,
  });

  const handleToggleState = (name: TogglerKeys) => {
    setTogglersState(prevState => ({
      ...prevState,
      [name]: !prevState[name],
    }));
  };

  const reorderedArray = Object.values(data).sort((a, b) => {
    return order.indexOf(a.type) - order.indexOf(b.type);
  });
  const activeData = Object.values(reorderedArray)[activeTopic];

  const { t } = useTranslation();

  const challengeName = t(`report.effect.topics.five.${convertTypeString(activeData.type)}`);

  return (
    <Wrapper>
      <HeaderWrapper>
        <Header>{challengeName}</Header>
        <Legend>
          <ValueColorBlocks shape="square" direction="row" flattened={true} data={activeData} />
          <FlexBlock>
            <VariationSign />
            <Text>{t('report.effect.timestamps.variationBetweenRespondents')}</Text>
            <Toggler name="variation_between_respondents" handleToggleState={handleToggleState} />
          </FlexBlock>
        </Legend>
      </HeaderWrapper>
      <FiveChallengesCarousel
        data={activeData}
        activeTopic={activeTopic}
        setActiveTopic={setActiveTopic}
        insightsEntity={data}
        togglersState={togglersState}
        challengeName={challengeName}
      />
    </Wrapper>
  );
};

export default FiveChallengesGroupTemplate;
